module.exports = __webpack_public_path__ + "img/10brice.335598a9.jpg";